export const GARMENT_TYPES = [
  { id: "suit", name: "Custom Suit", desc: "Two- or three-piece, cut to your design" },
  { id: "sport-coat", name: "Custom Sport Coat", desc: "A jacket with character, made for you" },
  { id: "trousers", name: "Custom Trousers", desc: "Perfect-fitting pants in your cloth" },
];

export const OPTION_SETS = {
  suit: [
    { key: "Pieces", values: ["Two-Piece", "Three-Piece"] },
    { key: "Lapel", values: ["Notch", "Peak", "Shawl"] },
    { key: "Buttons", values: ["One Button", "Two Button", "Three Button", "Double-Breasted"] },
    { key: "Vents", values: ["Side Vents", "Center Vent", "No Vent"] },
    { key: "Fit", values: ["Slim", "Tailored", "Classic"] },
    { key: "Construction", values: ["Half Canvas", "Full Canvas", "Fully Handmade"] },
    { key: "Lining", values: ["Tonal", "Contrast Colour", "Silk Print"] },
  ],
  "sport-coat": [
    { key: "Lapel", values: ["Notch", "Peak", "Shawl"] },
    { key: "Buttons", values: ["One Button", "Two Button", "Three Button", "Double-Breasted"] },
    { key: "Vents", values: ["Side Vents", "Center Vent", "No Vent"] },
    { key: "Fit", values: ["Slim", "Tailored", "Classic"] },
    { key: "Construction", values: ["Half Canvas", "Full Canvas", "Fully Handmade"] },
    { key: "Lining", values: ["Tonal", "Contrast Colour", "Silk Print", "Unlined"] },
  ],
  trousers: [
    { key: "Front", values: ["Flat Front", "Single Pleat", "Double Pleat"] },
    { key: "Waistband", values: ["Belt Loops", "Side Adjusters"] },
    { key: "Hem", values: ["Plain Hem", "Cuffed"] },
    { key: "Fit", values: ["Slim", "Tailored", "Classic"] },
  ],
};

export const PROCESS_STEPS = [
  {
    n: "01",
    title: "Design your garment",
    text: "Choose your cloth from the world's finest mills, then shape every detail — lapel, buttons, lining, fit.",
  },
  {
    n: "02",
    title: "Your measurements",
    text: "We take your measurements in person in San Diego, or guide you step by step through a video measurement session.",
  },
  {
    n: "03",
    title: "The basted fitting",
    text: "A basted (trial) garment is hand-made and sent to you. A local stylist meets you to fit it on your body and re-measure every line before the final garment is cut.",
  },
  {
    n: "04",
    title: "The final garment",
    text: "Your garment is finished by our Italian tailoring houses and delivered to you. Please allow up to eight weeks from cloth to closet.",
  },
];

export const fabricImg = (f) =>
  f?.image_url?.startsWith("/api")
    ? `${process.env.REACT_APP_BACKEND_URL}${f.image_url}`
    : f?.image_url || "";

const CONSTRUCTION_ADD = { "Half Canvas": 0, "Full Canvas": 500, "Fully Handmade": 1400 };
const GARMENT_FACTOR = { suit: 1, "sport-coat": 0.72, trousers: 0.22 };

export const estimatePrice = (fabric, garment, options) => {
  const base = fabric?.price_from;
  if (!base) return null;
  let p = base * (GARMENT_FACTOR[garment] ?? 1);
  if (garment !== "trousers") p += CONSTRUCTION_ADD[options?.Construction] || 0;
  if (garment === "suit" && options?.Pieces === "Three-Piece") p += 450;
  return Math.round(p / 5) * 5;
};

export const fmtPrice = (n) => (n == null ? "" : `$${n.toLocaleString("en-US")}`);

export const videoEmbed = (url) => {
  if (!url) return null;
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{6,})/);
  if (yt) return { type: "iframe", src: `https://www.youtube.com/embed/${yt[1]}` };
  const vm = url.match(/vimeo\.com\/(\d+)/);
  if (vm) return { type: "iframe", src: `https://player.vimeo.com/video/${vm[1]}` };
  return { type: "video", src: url };
};
